<template>
  <Teleport to="body">
    <div
        v-if="show"
        class="link-menu"
        :style="{ top: position.top + 'px', left: position.left + 'px' }"
    >
      <input
          v-model="url"
          class="link-input mb-1"
          placeholder="https://..."
          @keydown.enter.prevent="apply"
      />

      <textarea
          ref="textarea"
          v-model="text"
          class="link-input textarea"
          rows="1"
          placeholder="Текст ссылки"
          @input="autoResize"
      />

      <div class="link-actions">
        <button @click="apply">✔</button>
        <button v-if="editor.isActive('link')" @click="remove">✕</button>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { TextSelection } from 'prosemirror-state'

export default {
  name: 'TiptapLinkMenu',

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      show: false,
      url: '',
      text: '',
      position: {
        top: 0,
        left: 0,
      },
    }
  },

  mounted() {
    // ❗ ВАЖНО: именно onClick
    this.editor.view.dom.addEventListener('click', this.onClick)
  },

  beforeUnmount() {
    this.editor.view.dom.removeEventListener('click', this.onClick)
  },

  methods: {
    /* ================= POSITION ================= */

    updatePosition() {
      const { view, state } = this.editor
      const { from, to } = state.selection

      const start = view.coordsAtPos(from)
      const end = view.coordsAtPos(to)

      const MENU_WIDTH = 320
      const PADDING = 100

      // 👇 ВАЖНО: добавляем scroll
      const scrollX = window.scrollX
      const scrollY = window.scrollY

      let left =
          (start.left + end.right) / 2 -
          MENU_WIDTH / 2 +
          scrollX

      let top =
          start.top +
          scrollY +
              50

      left = Math.max(
          PADDING,
          Math.min(left, document.documentElement.scrollWidth - MENU_WIDTH - PADDING)
      )
          - 50

      top = Math.max(PADDING, top) - 20

      this.position = { top, left }
    },

    /* ================= TEXTAREA ================= */

    autoResize() {
      const el = this.$refs.textarea
      if (!el) return

      el.style.height = 'auto'
      el.style.height = el.scrollHeight + 'px'
    },

    /* ================= ACTIONS ================= */

    apply() {
      if (!this.url) return

      const { from, to } = this.editor.state.selection

      this.editor
          .chain()
          .focus()
          .insertContentAt(
              { from, to },
              {
                type: 'text',
                text: this.text || this.url,
                marks: [
                  {
                    type: 'link',
                    attrs: { href: this.url },
                  },
                ],
              }
          )
          .run()

      this.close()
    },

    remove() {
      this.editor.chain().focus().unsetLink().run()
      this.close()
    },

    close() {
      this.show = false
      this.url = ''
      this.text = ''
    },

    /* ================= CLICK HANDLER ================= */

    open() {
      const { state } = this.editor
      if (state.selection.empty) return

      const attrs = this.editor.getAttributes('link')

      this.url = attrs.href || ''
      this.text = state.doc.textBetween(
          state.selection.from,
          state.selection.to
      )

      this.show = true

      this.$nextTick(() => {
        this.updatePosition()
        this.autoResize()
      })
    },

    onClick(e) {
      const link = e.target.closest('a')

      if (!link) {
        this.close()
        return
      }

      e.preventDefault()
      e.stopPropagation()

      // Ctrl / Cmd + click → открыть ссылку
      if (e.ctrlKey || e.metaKey) {
        window.open(link.href, '_blank')
        return
      }

      const { view, state } = this.editor

      const from = view.posAtDOM(link, 0)
      const to = view.posAtDOM(link, link.childNodes.length)

      if (from == null || to == null || from > to) {
        this.close()
        return
      }

      view.dispatch(
          state.tr.setSelection(
              TextSelection.create(state.doc, from, to)
          )
      )
      view.focus()

      this.url = link.getAttribute('href') || ''
      this.text = link.textContent || ''

      this.show = true

      this.$nextTick(() => {
        this.updatePosition()
        this.autoResize()
      })
    },
  },
}
</script>